export const TOOLS = {
  /** Select / move annotations (no drawing). */
  SELECT: "select",
  PEN: "pen",
  TEXT: "text",
  SHAPE: "shape",
  HIGHLIGHT: "highlight",
  SQUIGGLY: "squiggly",
  CONNECTION: "connection",
  CALLOUT: "callout",
  PAN: "pan",
};

export const SHAPES = {
  LINE: "line",
  RECTANGLE: "rectangle",
  CIRCLE: "circle",
  ARROW: "arrow",
  POLYGON: "polygon",
  CLOUD: "cloud",
};

export const COLORS = ["red", "green", "blue", "black"];

export const HITBOX_PADDING = 12;
export const CLOUD_CLOSE_DISTANCE = 24;

/** Fixed default text-box width; typing wraps instead of growing sideways. */
export const TEXT_ANNOTATION_DEFAULT_WIDTH = 200;
export const TEXT_ANNOTATION_MIN_WIDTH = 80;
export const TEXT_ANNOTATION_MAX_WIDTH = 480;
export const TEXT_ANNOTATION_LINE_HEIGHT_FACTOR = 1.3;
/** Left inset of glyphs inside the text box (matches editor padding). */
export const TEXT_ANNOTATION_CONTENT_INSET = 4;

export const CALLOUT_KNEE_LENGTH = 20;
export const CALLOUT_ARROW_LENGTH = 12;
export const CALLOUT_STROKE_WIDTH = 1.5;
export const CALLOUT_CLICK_OFFSET = 60;

// RFI Connection tag dimensions (used consistently across all components)
export const RFI_TAG_WIDTH = 90;
export const RFI_TAG_HEIGHT = 24;
export const CONNECTION_INNER_RECT_INSET = 8;

export const CALLOUT_LINK_RESOLVED = "#0d9488";
export const CALLOUT_LINK_UNRESOLVED = "#8c8c8c";
export const SHEET_LINK_MIN_HIT_PX = 24;

